import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling"); // polling | paid | failed
  const { clear } = useCart();
  const attemptsRef = useRef(0);
  const clearedRef = useRef(false);

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    let stopped = false;

    const poll = async () => {
      if (stopped) return;
      attemptsRef.current += 1;
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          if (!clearedRef.current) { clear(); clearedRef.current = true; }
          return;
        }
        if (data.status === "expired") {
          setStatus("failed"); return;
        }
        if (attemptsRef.current >= 8) { setStatus("failed"); return; }
        setTimeout(poll, 2000);
      } catch {
        if (attemptsRef.current >= 8) setStatus("failed");
        else setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { stopped = true; };
  }, [sessionId]);

  return (
    <div data-testid="checkout-success-page" className="max-w-2xl mx-auto px-6 py-32 text-center">
      {status === "polling" && (
        <>
          <Loader2 className="animate-spin mx-auto text-alimi-gold" size={48} />
          <div className="font-serif text-3xl mt-8">Stiamo verificando il pagamento…</div>
          <p className="text-sm text-alimi-inkSoft mt-4">Un attimo, non chiudere la pagina.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 className="mx-auto text-alimi-gold" size={56} strokeWidth={1.4} />
          <div className="overline mt-8">Ordine confermato</div>
          <h1 data-testid="success-title" className="font-serif text-4xl sm:text-5xl mt-4 tracking-tight">Grazie di cuore.</h1>
          <p className="text-sm text-alimi-inkSoft mt-6 leading-relaxed">
            Il tuo pagamento è stato ricevuto. Ti invieremo presto una email con i dettagli
            dell'ordine e le informazioni di spedizione.
          </p>
          <Link to="/shop" className="btn-outline mt-10" data-testid="back-to-shop">Continua lo shopping</Link>
        </>
      )}
      {status === "failed" && (
        <>
          <div className="font-serif text-4xl tracking-tight">Pagamento non riuscito</div>
          <p className="text-sm text-alimi-inkSoft mt-5">Qualcosa è andato storto. Puoi riprovare dal carrello.</p>
          <Link to="/checkout" className="btn-primary mt-8" data-testid="retry-checkout">Riprova</Link>
        </>
      )}
    </div>
  );
}
